<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="licenca vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("licencas") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("licencas")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !licencaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'new-licenca' })"
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="changeSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="licenca-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="alllicencas"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key == 'status' ? 'situacao' : f.key) : ''"
                                :width="f.width"
                                :class="
                                    f.key != 'excluir' ? '' : 'excluir-field'
                                "
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'edit-licenca',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'bloqueiavenda'">
                                    {{$t( props.row['bloqueiavenda'] == 1 ? "sim" : "nao")}}
                                </div>
                                <div v-else-if="f.key == 'excluir'" >
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(
                                                props.row
                                            )
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'status'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t("ativo") }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t("inativo") }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import LicencaService from "@/services/LicencaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (["new-licenca", "edit-licenca"].includes(to.name)) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            licencaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("LICENCA"),
            alllicencas: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new LicencaService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: '10%', sortable: true, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "bloqueiavenda", label: "bloqueio-venda", width: 80, sortable: true, sortFn: null },
                { key: "status", label: "situacao", width: 100, sortable: true, sortFn: null },
                { key: "excluir", width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            deleteThis: {},
            permissao: {},
            sort: {
                order: "desc",
                column: "DESCRICAO",
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (["new-licenca", "edit-licenca"].includes(this.$route.name)) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "licencas"
        );
        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "licencas" },
            });
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.sort.order,
                    this.sort.column,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.alllicencas = value;
                    this.isEmpty = this.alllicencas.length <= 0;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let licencalist = body.content.map((m) => {
                return {
                    id: m.idlicenca,
                    codigo: m.idlicencaerp,
                    descricao: m.descricao,
                    bloqueiavenda: m.bloqueiavenda,
                    status: m.status,
                    situacao: m.status,
                    excluir: "excluir-licenca",
                };
            });
            return licencalist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.deleteThis = row;
            let message = this.$t(
                    row.status == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        changeSituacao(t) {
            if (t) {
                this.status = t;
            } else {
                this.status = this.situacoes[0];
            }
            this.carregarDados();
        },
        updateSituacao() {
            let licenca = {
                idlicenca: this.deleteThis.id,
                status: this.deleteThis.status,
            } 
                
            this.isLoading = true;
            this.service
                .updateSituacao(licenca)
                .then((r) => {
                    let messageSuccess = this.$t(
                            r.content.status == 0
                                ? "msg-sucesso-ao-reativar-licenca"
                                : "msg-sucesso-ao-desativar-licenca", 
                            { n: this.$t("licenca") }
                        );

                    this.$root.showMessage("success", messageSuccess, true, false);
                    this.carregarDados(this.pagination.currentPage);
                    this.pagination.currentPage = 1;
                })
                .catch((e) => {
                    console.error("Erro ao excluir licenças.", e);
                    let messageFail = this.$t(
                            this.delete.status == 1
                                ? "msg-erro-ao-desativar-licenca"
                                : "msg-erro-ao-reativar-licenca", 
                            { n: this.$t("licenca") }
                        );

                    this.$root.showMessage("error", messageFail, true, false);
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.deleteThis = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .licenca .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .licenca .search-and-filter .search-bar {
        width: 100%;
    }

    .licenca .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
